export const Leftmenu = (resolve) => {
  require.ensure(['@/components/layout/Leftmenu'], () => {
    resolve(require('@/components/layout/Leftmenu'));
  });
};
export const Topbar = (resolve) => {
  require.ensure(['@/components/layout/Topbar'], () => {
    resolve(require('@/components/layout/Topbar'));
  });
};
export const Login = (resolve) => {
  require.ensure(['@/components/login/Index'], () => {
    resolve(require('@/components/login/Index'));
  });
};

// 首页
export const Home = (resolve) => {
  require.ensure(['@/components/home/Index'], () => {
    resolve(require('@/components/home/Index'));
  });
};
export const Homemain = (resolve) => {
  require.ensure(['@/components/home/Main'], () => {
    resolve(require('@/components/home/Main'));
  });
};
export const Homemessage = (resolve) => {
  require.ensure(['@/components/home/Message'], () => {
    resolve(require('@/components/home/Message'));
  });
};
export const Homeaffiche = (resolve) => {
  require.ensure(['@/components/home/Affiche'], () => {
    resolve(require('@/components/home/Affiche'));
  });
};
export const Homevfpmenu = (resolve) => {
  require.ensure(['@/components/home/Left'], () => {
    resolve(require('@/components/home/Left'));
  });
};
export const Homememo = (resolve) => {
  require.ensure(['@/components/home/Memo'], () => {
    resolve(require('@/components/home/Memo'));
  });
};
export const Homecontact = (resolve) => {
  require.ensure(['@/components/home/Contact'], () => {
    resolve(require('@/components/home/Contact'));
  });
};


// CRM部分
export const Crm = (resolve) => {
  require.ensure(['@/components/crm/Index'], () => {
    resolve(require('@/components/crm/Index'));
  });
};
export const Crmmain = (resolve) => {
  require.ensure(['@/components/crm/Main'], () => {
    resolve(require('@/components/crm/Main'));
  });
};
export const Crmvfpmenu = (resolve) => {
  require.ensure(['@/components/crm/Left'], () => {
    resolve(require('@/components/crm/Left'));
  });
};
export const Crmchance = (resolve) => {
  require.ensure(['@/components/crm/Chance'], () => {
    resolve(require('@/components/crm/Chance'));
  });
};
export const Crmchancestat = (resolve) => {
  require.ensure(['@/components/crm/Chancestat'], () => {
    resolve(require('@/components/crm/Chancestat'));
  });
};
export const Crmhope = (resolve) => {
  require.ensure(['@/components/crm/Hope'], () => {
    resolve(require('@/components/crm/Hope'));
  });
};
export const Crmhopecolleague = (resolve) => {
  require.ensure(['@/components/crm' +
  '/Hopecolleague'], () => {
    resolve(require('@/components/crm/Hopecolleague'));
  });
};
export const Crmhopeshare = (resolve) => {
  require.ensure(['@/components/crm/Hopeshare'], () => {
    resolve(require('@/components/crm/Hopeshare'));
  });
};
export const Crmhopestat = (resolve) => {
  require.ensure(['@/components/crm/Hopestat'], () => {
    resolve(require('@/components/crm/Hopestat'));
  });
};

// CRM部分
export const Client = (resolve) => {
  require.ensure(['@/components/client/Index'], () => {
    resolve(require('@/components/client/Index'));
  });
};
export const Clientmain = (resolve) => {
  require.ensure(['@/components/client/Main'], () => {
    resolve(require('@/components/client/Main'));
  });
};
export const Clientvfpmenu = (resolve) => {
  require.ensure(['@/components/client/Left'], () => {
    resolve(require('@/components/client/Left'));
  });
};
export const Clientsign = (resolve) => {
  require.ensure(['@/components/client/Sign'], () => {
    resolve(require('@/components/client/Sign'));
  });
};
export const Clientsigncolleague = (resolve) => {
  require.ensure(['@/components/client/Signcolleague'], () => {
    resolve(require('@/components/client/Signcolleague'));
  });
};
export const Clientsignshare = (resolve) => {
  require.ensure(['@/components/client/Signshare'], () => {
    resolve(require('@/components/client/Signshare'));
  });
};
export const Clientsignstat = (resolve) => {
  require.ensure(['@/components/client/Signstat'], () => {
    resolve(require('@/components/client/Signstat'));
  });
};
export const Clientcontract = (resolve) => {
  require.ensure(['@/components/client/Contract'], () => {
    resolve(require('@/components/client/Contract'));
  });
};


// 签到部分
export const Visit = (resolve) => {
  require.ensure(['@/components/visit/Index'], () => {
    resolve(require('@/components/visit/Index'));
  });
};
export const Visitmain = (resolve) => {
  require.ensure(['@/components/visit/Main'], () => {
    resolve(require('@/components/visit/Main'));
  });
};
export const Visitvfpmenu = (resolve) => {
  require.ensure(['@/components/visit/Left'], () => {
    resolve(require('@/components/visit/Left'));
  });
};
export const Visitrecord = (resolve) => {
  require.ensure(['@/components/visit/Record'], () => {
    resolve(require('@/components/visit/Record'));
  });
};
export const Visitstat = (resolve) => {
  require.ensure(['@/components/visit/Stat'], () => {
    resolve(require('@/components/visit/Stat'));
  });
};
export const Visitunit = (resolve) => {
  require.ensure(['@/components/visit/Unit'], () => {
    resolve(require('@/components/visit/Unit'));
  });
};


// 签到部分
export const Recruitment = (resolve) => {
  require.ensure(['@/components/recruitment/Index'], () => {
    resolve(require('@/components/recruitment/Index'));
  });
};
export const Recruitmentmain = (resolve) => {
  require.ensure(['@/components/recruitment/Main'], () => {
    resolve(require('@/components/recruitment/Main'));
  });
};
export const Recruitmentvfpmenu = (resolve) => {
  require.ensure(['@/components/recruitment/Left'], () => {
    resolve(require('@/components/recruitment/Left'));
  });
};
export const Recruitmenteesume = (resolve) => {
  require.ensure(['@/components/recruitment/Resume'], () => {
    resolve(require('@/components/recruitment/Resume'));
  });
};
export const Recruitmentinterview = (resolve) => {
  require.ensure(['@/components/recruitment/Interview'], () => {
    resolve(require('@/components/recruitment/Interview'));
  });
};


// 我的模块
export const User = (resolve) => {
  require.ensure(['@/components/user/Index'], () => {
    resolve(require('@/components/user/Index'));
  });
};
export const Usermain = (resolve) => {
  require.ensure(['@/components/user/Main'], () => {
    resolve(require('@/components/user/Main'));
  });
};
export const Uservfpmenu = (resolve) => {
  require.ensure(['@/components/user/Left'], () => {
    resolve(require('@/components/user/Left'));
  });
};
export const Userlogs = (resolve) => {
  require.ensure(['@/components/user/Logs'], () => {
    resolve(require('@/components/user/Logs'));
  });
};


// 我的模块
export const Setting = (resolve) => {
  require.ensure(['@/components/setting/Index'], () => {
    resolve(require('@/components/setting/Index'));
  });
};
export const Settingvfpmenu = (resolve) => {
  require.ensure(['@/components/setting/Left'], () => {
    resolve(require('@/components/setting/Left'));
  });
};
export const Settingaccount = (resolve) => {
  require.ensure(['@/components/setting/Account'], () => {
    resolve(require('@/components/setting/Account'));
  });
};
export const Settingrole = (resolve) => {
  require.ensure(['@/components/setting/Role'], () => {
    resolve(require('@/components/setting/Role'));
  });
};
export const Settinglogs = (resolve) => {
  require.ensure(['@/components/setting/Logs'], () => {
    resolve(require('@/components/setting/Logs'));
  });
};
export const Settingclient = (resolve) => {
  require.ensure(['@/components/setting/Client'], () => {
    resolve(require('@/components/setting/Client'));
  });
};
export const Settingcrm = (resolve) => {
  require.ensure(['@/components/setting/Crm'], () => {
    resolve(require('@/components/setting/Crm'));
  });
};
export const Settinglink = (resolve) => {
  require.ensure(['@/components/setting/Link'], () => {
    resolve(require('@/components/setting/Link'));
  });
};
export const Settingrecruitment = (resolve) => {
  require.ensure(['@/components/setting/Recruitment'], () => {
    resolve(require('@/components/setting/Recruitment'));
  });
};
export const Settingvisit = (resolve) => {
  require.ensure(['@/components/setting/Visit'], () => {
    resolve(require('@/components/setting/Visit'));
  });
};
export const Crmrecycle = (resolve) => {
  require.ensure(['@/components/crm/Recycle'], () => {
    resolve(require('@/components/crm/Recycle'));
  });
};
export const Crmhintduty = (resolve) => {
  require.ensure(['@/components/crm/Hintduty'], () => {
    resolve(require('@/components/crm/Hintduty'));
  });
};
export const Crmhintshare = (resolve) => {
  require.ensure(['@/components/crm/Hintshare'], () => {
    resolve(require('@/components/crm/Hintshare'));
  });
};
export const Crmblacklist = (resolve) => {
  require.ensure(['@/components/crm/Blacklist'], () => {
    resolve(require('@/components/crm/Blacklist'));
  });
};
export const Crmlecture = (resolve) => {
  require.ensure(['@/components/lecture/Lecture'], () => {
    resolve(require('@/components/lecture/Lecture'));
  });
};
export const Crmfilter = (resolve) => {
  require.ensure(['@/components/crm/Filter'], () => {
    resolve(require('@/components/crm/Filter'));
  });
};



// WEBPACK FOOTER //
// ./src/router/imports.js